/* projects/speaker-platform/src/app/atoms/toasts/toasts.component.scss */
:host {
  position: fixed;
  top: 0;
  right: 0;
  margin: 0.5em;
  z-index: 1200;
}
.danger {
  background-color: #FF7474;
  color: #952626;
}
.success {
  background-color: #99FF74;
  color: #289526;
}
.warning {
  background-color: #FFC107;
  color: #9A7407;
}
.info {
  background-color: #74E4FD;
  color: #dadada;
}
/*# sourceMappingURL=toasts.component-EI2UPYCA.css.map */
